// extracted by mini-css-extract-plugin
module.exports = {"recipe":"Recipes_recipe__14Jot","img":"Recipes_img__PUk5I"};